import React from "react";
import useMatchupStore from "../store/MatchupStore";
import { refreshMatchupData } from "../utils/matchupUtils";

function RefreshButton() {
  const [isRefreshing] = useMatchupStore((state) => [state.isRefreshing]);

  return (
    <button
      onClick={refreshMatchupData}
      disabled={isRefreshing}
      className="inline-flex touch-manipulation items-center justify-center px-1 -mx-1 md:px-0 md:mx-0 disabled:opacity-50"
    >
      <span className="h4 mb-0 inline-flex gap-1.5 items-center justify-center rounded-full border border-gray-300 bg-white px-1.5 md:px-3.5 py-1.5 text-center text-xs font-medium text-gray-900 md:hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 md:dark:hover:bg-gray-700 dark:focus:ring-gray-800">
        <span className="hidden md:inline">Refresh</span>
        <svg
          className={`w-5 h-5 text-gray-800 dark:text-white ${isRefreshing ? "animate-spin" : ""}`}
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
          />
        </svg>
      </span>
    </button>
  );
}

export default RefreshButton;
